<template>
  <div class="hotelTune">
    <h4 class="hotelTuneTitle">
      <tk-svg-icon class="icoTune" icon="tune" />
      絞り込み
    </h4>
    <div class="hotelTuneNavi">
      <ul class="hotelTuneList">
        <button
          v-for="(value, name) in filters"
          :key="name"
          class="hotelTuneItem"
          :class="{ active: selectedFilters[name] }"
          @click.prevent="select(name)"
        >
          {{ value }}
        </button>
      </ul>
    </div>
  </div>
</template>

<script>
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon.vue'

export default {
  name: 'TkPlanFilter',
  components: {
    TkSvgIcon,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedFilters: {},
    }
  },
  methods: {
    select(key) {
      if (this.selectedFilters[key]) {
        this.$delete(this.selectedFilters, key)
      } else {
        this.$set(this.selectedFilters, key, true)
      }
      this.$emit('filter', this.selectedFilters)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@ota-frontend/ui/src/scss/components/TkPlanFilter.scss';
</style>
